import React from 'react';
import { SBox } from '@avalara/skylab-sdk/react';
import { LightGreyRoundedBox } from '../styled';
const OfferBox = ({ children, className, id, isEmbedded }) => (isEmbedded
    ? React.createElement(SBox, { id: id, class: `secondary ${className !== null && className !== void 0 ? className : ''}` }, children)
    : React.createElement(LightGreyRoundedBox, { "data-ref": 'buy.offerBox', id: id, className: className !== null && className !== void 0 ? className : '' }, children));
export default OfferBox;
